<template>
  <div class="detail">
    <p>
      <i class="el-icon-s-home"></i>
      <span>网站首页</span>
      / 法律事务/ {{content.typeName}}
    </p>
    <div class="content" v-html="content.content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    var data = JSON.parse(sessionStorage.getItem("classic_case"));
    this.content = data;
  },
  methods: {},
};
</script>
<style scoped>
.detail > p {
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  color: gray;
}

.detail > p i {
  margin-right: 10px;
}

.detail .content {
  line-height: 30px;
  padding: 20px 30px;
  box-sizing: border-box;
  color: gray;
  font-size: 13px;
}
</style>
